import set from "lodash/set";

const initStat = null;

const loanPipelineReducer = (state = initStat, action) => {
  let newState = { ...state };
  switch (action.type) {
    case "SET_LOAN_PIPELINE":
      return action.payload;

    case "SET_LOAN_PIPELINE_KEY":
      return set(newState, action.payload.key, action.payload.value);

    // Update a single field on a single loan in the pipeline list, in place
    // (immutably). Used after an inline cell edit so only that value changes —
    // avoids a full refetch (whose loan shape differs from the pipeline rows).
    case "UPDATE_LOAN_PIPELINE_FIELD": {
      if (!Array.isArray(state)) return state;
      const { loanId, field, value } = action.payload;
      return state.map((loan) =>
        loan?._id === loanId ? { ...loan, [field]: value } : loan,
      );
    }

    case "CLEAR_LOAN_PIPELINE":
      return initStat;

    default:
      return state;
  }
};

export default loanPipelineReducer;
